import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eBrokerPortalRouteNames } from '../enums/route-names';
import { EnvService } from 'projects/dev-app/src/environments/env.service';


export const BROKER_PORTAL_ROUTE_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService,EnvService],
    multi: true,
  },
];

const getCurrentYear = (envService: EnvService): number => {
  let dt = envService.getTodayFromConfig().getFullYear();
  return dt;
};

export function configureRoutes(routes: RoutesService, envService: EnvService) {
  return () => {
    const currentYear = getCurrentYear(envService);
    const nextYear = currentYear + 1;
    routes.add([
      {
        path: '/broker-portal/enrollments',
        name: "Enrollment Status",
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
    routes.add([
      {
        path: '/broker-portal/soahistory',
        name: "SOA",
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
    routes.add([
      {
         path: `/broker-portal/soa/${currentYear}`,
        name: `New Enrollment ${currentYear}`,
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
    routes.add([
      {
        path: `/broker-portal/soa-nextyear/${nextYear}`,
        name: `New Enrollment ${nextYear}`,
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
    routes.add([
      {
        path: '/broker-portal/planComparison',
        name: "Plan Information",
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
    
    routes.add([
      {
        path: '/broker-portal/tools',
        name: "Tools",
        //iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);

    routes.add([
        {
          path: '/broker-portal/member-payment',
          name: "Commissions",
          //iconClass: 'fas fa-book',
          layout: eLayoutType.application,
          invisible: envService.displayPaymentPage,
          order: 3,
        },
      ]);

    
  };
}
